module.exports = __webpack_public_path__ + "assets/img/generate_output_tree_select.6b969b3b.png";